import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ shotGroupList returns list of all shot groups by user token
// * deprecating this one
export const shotGroupList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/shot_group_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ shotGroupCollectionList returns list of all shot groups by user token
// @ payload: {
// @    "type": 'practice' or 'gapping' or empty,
// @    "page_info": {
// @      "limit": 2,
// @      "offset": 1
// @  }
export const shotGroupCollectionList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/shot_group_collection_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ shotGroupGet returns list of all shot groups by user token
// @ payload: { id: 1234 }
export const shotGroupGet = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/shot_group_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ shotGroupUpsert updates a shot group
// @ payload: shot group object with any changes
export const shotGroupUpsert = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/shot_group_upsert`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ shotGroupCollectionUpdate updates a shot collection
// @ payload: id: collection ID, notes: String, status: String active or disabled
export const shotGroupCollectionUpdate = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/shot_group_collection_update`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
